import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

import colors from '@constants/colors';
import {
	RSRP_GOOD_MAX,
	RSRP_GOOD_MIN,
	RSRP_NO_SERVICE_MAX,
	RSRP_VARIABLE_MAX,
	RSRP_VARIABLE_MIN,
	RSRQ_GOOD_MAX,
	RSRQ_GOOD_MIN,
	RSRQ_NO_SERVICE_MAX,
	RSRQ_VARIABLE_MAX,
	RSRQ_VARIABLE_MIN,
} from '@components/Map/LegendaOokla/constants';

export const DEFAULT_COLOR = '#B3B3B3';

export const EOoklaMeasurementNames = {
	RSRP: 'RSRP',
	RSRQ: 'RSRQ',
} as const;

export const EDeviceTypes = {
	android: 'ANDROID',
	ios: 'IOS',
	unknown: 'UNKNOWN',
} as const;

export const EMeasurementTypes = {
	download: 'DOWNLOAD',
	upload: 'UPLOAD',
	unknown: 'UNKNOWN',
} as const;

export const EOoklaDisplayTypes = {
	colorRelatedAssets: 'COLOR_RELATED_ASSETS',
	showCoverage: 'SHOW_COVERAGE',
} as const;

export const EOoklaServiceLevel = {
	good: 'OOKLA_GOOD',
	variable: 'OOKLA_VARIABLE',
	noService: 'OOKLA_NO_SERVICE',
	unknown: 'OOKLA_UNKNOWN',
} as const;

export type TOoklaServiceLevel = TValueOfStringRecord<typeof EOoklaServiceLevel>
export type TOoklaDisplayTypes = TValueOfStringRecord<typeof EOoklaDisplayTypes>
export type TDeviceTypes = TValueOfStringRecord<typeof EDeviceTypes>
export type TMeasurementTypes = TValueOfStringRecord<typeof EMeasurementTypes>
export type TOoklaMeasurementNames = TValueOfStringRecord<typeof EOoklaMeasurementNames>

export const OoklaLegendRange = {
	RSRP: [
		{
			color: colors.serviceLevelGood,
			min: RSRP_GOOD_MIN,
			max: RSRP_GOOD_MAX,
			level: EOoklaServiceLevel.good,
		},
		{
			color: colors.serviceLevelVariable,
			min: RSRP_VARIABLE_MIN,
			max: RSRP_VARIABLE_MAX,
			level: EOoklaServiceLevel.variable,
		},
		{
			color: colors.serviceLevelNoService,
			min: -Infinity,
			max: RSRP_NO_SERVICE_MAX,
			level: EOoklaServiceLevel.noService,
		},
	],
	RSRQ: [
		{
			color: colors.serviceLevelGood,
			min: RSRQ_GOOD_MIN,
			max: RSRQ_GOOD_MAX,
			level: EOoklaServiceLevel.good,
		},
		{
			color: colors.serviceLevelVariable,
			min: RSRQ_VARIABLE_MIN,
			max: RSRQ_VARIABLE_MAX,
			level: EOoklaServiceLevel.variable,
		},
		{
			color: colors.serviceLevelNoService,
			min: -Infinity,
			max: RSRQ_NO_SERVICE_MAX,
			level: EOoklaServiceLevel.noService,
		},
	],
};
